import { ref } from "vue";

const isCollapsed = ref(false);
const showMobileSidebar = ref(false);

export function useSidebar() {
  const toggleCollapse = () => {
    isCollapsed.value = !isCollapsed.value;
  };

  const toggleMobileSidebar = () => {
    showMobileSidebar.value = !showMobileSidebar.value;
  };

  const closeMobileSidebar = () => {
    showMobileSidebar.value = false;
  };

  const openMobileSidebar = () => {
    showMobileSidebar.value = true;
  };

  return {
    isCollapsed,
    showMobileSidebar,
    toggleCollapse,
    toggleMobileSidebar,
    closeMobileSidebar,
    openMobileSidebar,
  };
}
